<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">William and the Pirates of Fruxiclay</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#chapter-1-as-silent-as-the-grave">Chapter 1: As Silent as the Grave</a>
</li>
<li id="toc-li-5"><a href="#/text/ch005#chapter-2-time-for-making-amends">Chapter 2: Time for Making Amends</a>
</li>
<li id="toc-li-6"><span href="#/text/ch006#chapter-3-selfless-magic" title="Link target outside of Sample">Chapter 3: Selfless Magic</span></li>
<li id="toc-li-7"><span href="#/text/ch007#chapter-4-the-pirates-from-fruxiclay" title="Link target outside of Sample">Chapter 4: The Pirates from
          Fruxiclay</span></li>
<li id="toc-li-8"><span href="#/text/ch008#chapter-5-the-sooly-worms" title="Link target outside of Sample">Chapter 5: The Sooly Worms</span></li>
<li id="toc-li-9"><span href="#/text/ch009#chapter-6-smell-the-coffee" title="Link target outside of Sample">Chapter 6: Smell the Coffee</span></li>
<li id="toc-li-10"><span href="#/text/ch010#chapter-7-the-invisible-ball" title="Link target outside of Sample">Chapter 7: The Invisible Ball</span></li>
<li id="toc-li-11"><span href="#/text/ch011#chapter-8-out-of-the-frying-pan" title="Link target outside of Sample">Chapter 8: Out of the Frying Pan…</span>
</li>
<li id="toc-li-12"><span href="#/text/ch012#chapter-9-into-the-fire" title="Link target outside of Sample">Chapter 9: Into the Fire…</span></li>
<li id="toc-li-13"><span href="#/text/ch013#chapter-10-in-dire-straits" title="Link target outside of Sample">Chapter 10: In Dire Straits</span></li>
<li id="toc-li-14"><span href="#/text/ch014#chapter-11-saved-by-the-bell" title="Link target outside of Sample">Chapter 11: Saved by the Bell</span></li>
<li id="toc-li-15"><span href="#/text/ch015#chapter-12-a-pleasant-surprise" title="Link target outside of Sample">Chapter 12: A Pleasant Surprise</span>
</li>
<li id="toc-li-16"><span href="#/text/ch016#chapter-13-dont-beat-about-the-bush" title="Link target outside of Sample">Chapter 13: Don’t Beat About the
          Bush…</span></li>
<li id="toc-li-17"><span href="#/text/ch017#chapter-14-all-that-ends-well" title="Link target outside of Sample">Chapter 14: All That Ends Well…</span>
</li>
<li id="toc-li-18"><span href="#/text/ch018#chapter-15-problem-solving" title="Link target outside of Sample">Chapter 15: Problem Solving</span></li>
<li id="toc-li-19"><span href="#/text/ch019#chapter-16-a-testing-time" title="Link target outside of Sample">Chapter 16: A Testing Time</span></li>
<li id="toc-li-20"><span href="#/text/ch020#chapter-17-home-again-once-more" title="Link target outside of Sample">Chapter 17: Home Again Once More?</span>
</li>
<li id="toc-li-21"><span href="#/text/ch021#chapter-18-the-grass-is-not-greener-on-the-other-side" title="Link target outside of Sample">Chapter 18: The
          Grass Is Not Greener on the Other Side</span></li>
<li id="toc-li-22"><span href="#/text/ch022#chapter-19-trying-to-get-back-home" title="Link target outside of Sample">Chapter 19: Trying to Get Back
          Home</span></li>
<li id="toc-li-23"><span href="#/text/ch023#chapter-20-still-trying-to-go-home" title="Link target outside of Sample">Chapter 20: Still Trying to Go
          Home…</span></li>
<li id="toc-li-24"><span href="#/text/ch024#chapter-21-where-is-the-milky-way" title="Link target outside of Sample">Chapter 21: Where Is the Milky
          Way?</span></li>
<li id="toc-li-25"><span href="#/text/ch025#chapter-22-home-at-last" title="Link target outside of Sample">Chapter 22: Home at Last</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?7733104e